import { render, staticRenderFns } from "./dialog-admin-link-to-conversation.vue?vue&type=template&id=2a225137&scoped=true&"
import script from "./dialog-admin-link-to-conversation.vue?vue&type=script&lang=js&"
export * from "./dialog-admin-link-to-conversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a225137",
  null
  
)

export default component.exports